import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  sent_to_sellers: "Sent to Sellers",
  quotes_received: "Quotes Received",
  customer_approved: "Customer Approved",
  po_issued: "PO Issued",
  closed: "Closed",
  cancelled: "Cancelled",
};

export const STATUS_COLORS: Record<string, string> = {
  draft: "bg-gray-100 text-gray-700",
  sent_to_sellers: "bg-blue-100 text-blue-700",
  quotes_received: "bg-orange-100 text-orange-700",
  customer_approved: "bg-emerald-100 text-emerald-700",
  po_issued: "bg-purple-100 text-purple-700",
  closed: "bg-slate-100 text-slate-600",
  cancelled: "bg-red-100 text-red-700",
};

export const RFQ_WORKFLOW_STEPS = [
  { key: "draft", label: "Draft" },
  { key: "sent_to_sellers", label: "Sent to Sellers" },
  { key: "quotes_received", label: "Quotes Received" },
  { key: "customer_approved", label: "Customer Approved" },
  { key: "po_issued", label: "PO Issued" },
  { key: "closed", label: "Closed" },
] as const;
